// react imports
import React, { useState } from "react";

// package imports
import { Row, Col, Form, Button } from "react-bootstrap";
import { observer } from "mobx-react";

// project imports
import { BottomsheetDropdown, ChangeProductSection, AdditionalRiderBenifitsCard, DatepickerModal } from "components";
import DeathCoverGraphSlider from "../../death-cover-graph-slider/DeathCoverGraphSlider";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";
import UiButton from "components/ui/button/Button";
import utils from "./utils";
import DeathBenefitAmount from "utils/optimization/deathBenefitAmount";
import CompareProductModal from "../../../../../components/ui/compare-products-modal/CompareProductsModal"

// CSS imports
import "../../optimization-card/family-collapse-view.css";
import moment from "moment";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import ComapreQuotesTable from "components/ui/compare-quotes-table/ComapreQuotesTable";
import StorageKeys from "constants/StorageKeys";

const LegacyPlus = ({ form, data }) => {
  let productData = data?.data?.BI.find((item) => item.risk === data?.data?.risk);
  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data.cardKey)

  return (
    <div className=''>
      <Row className="align-items-center mt-4">
        <Col md={12} className='mt-3 mt-md-0'>
          <ChangeProductSection
            productName={productData.product_name}
            cardName={coverLabelBaseOnNeed}
            changeProductList={data?.data?.changeProductList || []}
            productData={data} 
            form={form}
            />
            
        </Col>
        {/* <Col md={6} className="mb-4 mb-md-0">
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("payment-frequency").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("payment-frequency").label}
            menuList={form.$("payment-frequency").extra.optionList}
            value={form.$("payment-frequency").value}
            onSelect={form.$("payment-frequency").onChange}
          />
        </Col> */}
      </Row>
      
      <Row>
        <Col md={12}>
          <ComapreQuotesTable
           form={form}
            ptList={form.$("policy-term").extra.optionList}
            pptList={form.$("premium-term").extra.optionList}
            ptValueId={form.$("policy-term").value}
            ptName={"policy-term"}
            pptName={"premium-term"}
            productData={data}
            cardKey={data.cardKey}
          />
        </Col>
      </Row>

      <Col xs={12} className='mt-2 mt-md-0'>
        <DeathCoverGraphSlider
          productData={data?.data}
          saLabel='Income'
          productTitle={productData.product_name}
          openChangeReasonModal={() => { }}
          onIncomeChange={form.$("income").onChange}
          onPremiumChange={form.$("premium").onChange}
          dataChange={() => { }}
          hideOverLay={() => { }}
          productID={productData.product_id}
          cardKey={data.cardKey}
          income_value={form.$("income").value}
          premium_value={form.$("premium").value}
          showOverlay={false}
          onClick={() => form.$("premium").extra.calculatePremium(form, form.$("premium").value, data)}
          data={""}
          isIncomeFieldDisable={false}
          isPremiumDisable={false}
          premiumFreq={form.$("payment-frequency").value.label}
          onIncomeBlur={() => { form.$("income").extra.calculateIncome(form, data); }}
          formRef={form}
        />
      </Col>

      <Row className='mt-3 ml-0'>
        <p className='graph-label mb-2 font-size-12 font-size-md-14 font-weight-bold'>{"Sum Assured on Death (at inception of the policy):"}</p>
        <p className='graph-label pl-1 font-size-12 font-size-md-14 font-weight-bold'>{DeathBenefitAmount(productData)}</p>
      </Row>

      <Row className='mt-3'>
        <Col xs={12} md={6} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("policy-term").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={form.$("policy-term").onChange}
          />
        </Col>

        <Col xs={12} md={6} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("premium-term").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-term").label}
            menuList={form.$("premium-term").extra.optionList}
            value={form.$("premium-term").value}
            onSelect={form.$("premium-term").onChange}
          />
        </Col>

        {/* {!form.$("income-start-year").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("income-start-year").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("income-start-year").label}
              menuList={form.$("income-start-year").extra.optionList}
              value={form.$("income-start-year").value}
              onSelect={form.$("income-start-year").onChange}
            />
          </Col>} */}

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("plan-option").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("plan-option").label}
            menuList={form.$("plan-option").extra.optionList}
            value={form.$("plan-option").value}
            onSelect={form.$("plan-option").onChange}
            disabled={form.$("plan-option").disabled}
          />
        </Col>

        {/* <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("life-cover").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("life-cover").label}
            menuList={form.$("life-cover").extra.optionList}
            value={form.$("life-cover").value}
            onSelect={form.$("life-cover").onChange}
            disabled={form.$("life-cover").disabled}
          />
        </Col> */}

        <Col xs={12} md={4} className='mb-3'>
          <p className='mb-2 font-size-12 font-weight-light '>{form.$("payment-frequency").label}</p>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("payment-frequency").label}
            menuList={form.$("payment-frequency").extra.optionList}
            value={form.$("payment-frequency").value}
            onSelect={form.$("payment-frequency").onChange}
            disabled={form.$("payment-frequency").disabled}
          />
        </Col>


        {form.$("second-life-assured-first-name").extra.hide &&

          <Col xs={12} md={4} className='mb-3' >

            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("second-life-assured-first-name").label}
            </div>

            <Form.Control
              className="font-size-12 font-weight-light text-black product-form-field"
              placeholder={form.$("second-life-assured-first-name").label}
              value={form.$("second-life-assured-first-name").value}
              onChange={form.$('second-life-assured-first-name').onChange}
              onBlur={() => form.$('second-life-assured-first-name').extra.onSecondLANameChange(form, data)}
              disabled={form.$("second-life-assured-first-name").disabled}
            />

          </Col>
        }

        {form.$("second-life-assured-last-name").extra.hide &&

          <Col xs={12} md={4} className='mb-3' >

            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("second-life-assured-last-name").label}
            </div>

            <Form.Control
              className="font-size-12 font-weight-light text-black product-form-field"
              placeholder={form.$("second-life-assured-last-name").label}
              value={form.$("second-life-assured-last-name").value}
              onChange={form.$('second-life-assured-last-name').onChange}
              onBlur={() => form.$('second-life-assured-last-name').extra.onSecondLANameChange(form, data)}
              disabled={form.$("second-life-assured-last-name").disabled}
            />

          </Col>
        }

        {form.$("second-life-assured-gender").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("second-life-assured-gender").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("second-life-assured-gender").label}
              menuList={form.$("second-life-assured-gender").extra.optionList}
              value={form.$("second-life-assured-gender").value}
              onSelect={form.$("second-life-assured-gender").onChange}
              disabled={form.$("second-life-assured-gender").disabled}
            />
          </Col>
        }

        {form.$("second-life-assured-dob").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <div className="mb-2 text-description-text-color font-size-12 font-weight-light">
              {form.$("second-life-assured-dob").label}
            </div>
            <DatepickerModal
              date={form.$("second-life-assured-dob").value}
              value={form.$("second-life-assured-dob").value}
              textStyle='font-size-12 font-weight-light text-black text-nowrap overflow-hidden txt-overflow'
              onChange={(value) => form.$("second-life-assured-dob").extra.onSecondLADobChange(value, form, data)}
              // disabled={form.$('marital-status').value.id == 9}
              disabled={form.$("second-life-assured-dob").disabled }
              minDate={""}
              maxDate={moment().subtract(18, "years").toString()}
            />
          </Col>
        }
        {!form.$("accrual-of-survival-benefit").extra.hide &&
          <Col xs={12} md={4} className='mb-3'>
            <p className='mb-2 font-size-12 font-weight-light '>{form.$("accrual-of-survival-benefit").label}</p>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefit").label}
              menuList={form.$("accrual-of-survival-benefit").extra.optionList}
              value={form.$("accrual-of-survival-benefit").value}
              onSelect={form.$("accrual-of-survival-benefit").onChange}
              disabled={form.$("accrual-of-survival-benefit").disabled}
            />
          </Col>
        }
        {!form.$("asb-start-age-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(1st-opt-in)").label}
              menuList={form.$("asb-start-age-(1st-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(1st-opt-in)").value}
              onSelect={form.$("asb-start-age-(1st-opt-in)").onChange}
              disabled={form.$("asb-start-age-(1st-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-end-age-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(1st-opt-in)").label}
              menuList={form.$("asb-end-age-(1st-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(1st-opt-in)").value}
              onSelect={form.$("asb-end-age-(1st-opt-in)").onChange}
              disabled={form.$("asb-end-age-(1st-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("withdrawal-parcentage-1").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-1").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-1").label}
              menuList={form.$("withdrawal-parcentage-1").extra.optionList}
              value={form.$("withdrawal-parcentage-1").value}
              onSelect={form.$("withdrawal-parcentage-1").onChange}
              disabled={form.$("withdrawal-parcentage-1").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("accrual-of-survival-benefits-year-2").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits-year-2").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefits-year-2").label}
              menuList={form.$("accrual-of-survival-benefits-year-2").extra.optionList}
              value={form.$("accrual-of-survival-benefits-year-2").value}
              onSelect={form.$("accrual-of-survival-benefits-year-2").onChange}
              disabled={form.$("accrual-of-survival-benefits-year-2").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-start-age-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(2nd-opt-in)").label}
              menuList={form.$("asb-start-age-(2nd-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(2nd-opt-in)").value}
              onSelect={form.$("asb-start-age-(2nd-opt-in)").onChange}
              disabled={form.$("asb-start-age-(2nd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-end-age-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(2nd-opt-in)").label}
              menuList={form.$("asb-end-age-(2nd-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(2nd-opt-in)").value}
              onSelect={form.$("asb-end-age-(2nd-opt-in)").onChange}
              disabled={form.$("asb-end-age-(2nd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>

        }

        {!form.$("withdrawal-parcentage-2").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-2").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-2").label}
              menuList={form.$("withdrawal-parcentage-2").extra.optionList}
              value={form.$("withdrawal-parcentage-2").value}
              onSelect={form.$("withdrawal-parcentage-2").onChange}
              disabled={form.$("withdrawal-parcentage-2").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("accrual-of-survival-benefits-year-3").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits-year-3").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefits-year-3").label}
              menuList={form.$("accrual-of-survival-benefits-year-3").extra.optionList}
              value={form.$("accrual-of-survival-benefits-year-3").value}
              onSelect={form.$("accrual-of-survival-benefits-year-3").onChange}
              disabled={form.$("accrual-of-survival-benefits-year-3").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-start-age-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-age-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-age-(3rd-opt-in)").label}
              menuList={form.$("asb-start-age-(3rd-opt-in)").extra.optionList}
              value={form.$("asb-start-age-(3rd-opt-in)").value}
              onSelect={form.$("asb-start-age-(3rd-opt-in)").onChange}
              disabled={form.$("asb-start-age-(3rd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-end-age-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-age-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-age-(3rd-opt-in)").label}
              menuList={form.$("asb-end-age-(3rd-opt-in)").extra.optionList}
              value={form.$("asb-end-age-(3rd-opt-in)").value}
              onSelect={form.$("asb-end-age-(3rd-opt-in)").onChange}
              disabled={form.$("asb-end-age-(3rd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("withdrawal-parcentage-3").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("withdrawal-parcentage-3").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("withdrawal-parcentage-3").label}
              menuList={form.$("withdrawal-parcentage-3").extra.optionList}
              value={form.$("withdrawal-parcentage-3").value}
              onSelect={form.$("withdrawal-parcentage-3").onChange}
              disabled={form.$("withdrawal-parcentage-3").disabled}
            />
            {/* </div> */}
          </Col>
        }
      </Row>



      <Row className="mt-4">
        <Col md={6} className="col-12 my-4 ">
          <AdditionalRiderBenifitsCard
            data={data}
            form={form}
            showCriticalIllness={!form.$("CriticalIllnessRider").extra.hide}
            showIncomeBenefit={!form.$("IncomeBenefitRider").extra.hide}
            showHospitalityCashBenefit={false}
            showWOP={!form.$("WaiverOfPremiumRider").extra.hide}
            showPWB={!form.$("PayorWaiverBenefitRider").extra.hide}
            showADB={!form.$("ADB").extra.hide}
            showATPD={!form.$("ATPDRider").extra.hide}
          />
        </Col>
      </Row>
    </div>
  );
};

export default observer(LegacyPlus);


